import { motion } from "framer-motion";

export function Section({ children, className = "", id, testId }) {
  return (
    <section id={id} data-testid={testId} className={`py-24 sm:py-32 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <div className={`text-xs uppercase tracking-[0.22em] font-semibold text-blue-600 mb-4 ${className}`}>
      {children}
    </div>
  );
}

export function SectionHeading({ eyebrow, title, intro, align = "left", testId }) {
  return (
    <div
      className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}`}
      data-testid={testId}
    >
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
        {title}
      </h2>
      {intro && <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{intro}</p>}
    </div>
  );
}

export function FadeIn({ children, delay = 0, y = 16, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.55, ease: "easeOut", delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, stagger = 0.08 }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: stagger } },
      }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, y = 18, className = "" }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y },
        visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
